import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\UpdateFamilySpaceDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/UpdateFamilySpaceDossierByIdController.php
* @route '/api/dossier/{dossier}/family-space'
*/
const UpdateFamilySpaceDossierByIdController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateFamilySpaceDossierByIdController.url(args, options),
    method: 'put',
})

UpdateFamilySpaceDossierByIdController.definition = {
    methods: ["put"],
    url: '/api/dossier/{dossier}/family-space',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\UpdateFamilySpaceDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/UpdateFamilySpaceDossierByIdController.php
* @route '/api/dossier/{dossier}/family-space'
*/
UpdateFamilySpaceDossierByIdController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return UpdateFamilySpaceDossierByIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\UpdateFamilySpaceDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/UpdateFamilySpaceDossierByIdController.php
* @route '/api/dossier/{dossier}/family-space'
*/
UpdateFamilySpaceDossierByIdController.put = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateFamilySpaceDossierByIdController.url(args, options),
    method: 'put',
})

export default UpdateFamilySpaceDossierByIdController